import { render, staticRenderFns } from "./CommunityOverview.vue?vue&type=template&id=152d5f95&"
import script from "./CommunityOverview.vue?vue&type=script&lang=ts&"
export * from "./CommunityOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports